import { Component, OnInit} from '@angular/core';


@Component({
    templateUrl: './revalidation.component.html',
    styleUrls: ['../style/_dashboard.scss'],
    standalone: false
})
export class RevalidationComponent implements OnInit {


  ngOnInit() { }


}
